const TOOLTIP_REGISTER_MESSAGES = {
    LAST_NAME:
        'Enter Last Name as it appears on your Member ID card, including the suffix Jr., Sr., I, II, III, IV, etc.',
    MEMBER_ID:
        'Your Member ID is an 11 digit number that can be found at the top of your ID Card.',
};

export { TOOLTIP_REGISTER_MESSAGES };
